import { asMaybeasy, Maybe } from '@execonline-inc/structured-maybe';
import { observer } from 'mobx-react';
import * as React from 'react';
import Status from '../Status';

interface Props {
  publishedAt: Maybe<Date>;
}

const PublishedAtStatus: React.FC<Props> = ({ publishedAt }) =>
  asMaybeasy(publishedAt)
    .map(() => <Status status="Active" backgroundColor="bg-green-700" />)
    .getOrElse(() => <Status status="Draft" backgroundColor="bg-gray-500" />);

export default observer(PublishedAtStatus);
